(function (window, undefined) {
    'use strict';

    var app,
        fn = {},
        _fn = {},
        headerOffsetTop,
        headerHeight,
        changeHeight,
        $window,
        isSitetop,
        console;

    fn.init = function () {

        console = window.console;
        console.log('header callled');
        var $header = $('.header');
        var headerOffsetTop = $header.offset().top;
        var headerHeight = $header.height();
        changeHeight = headerHeight - headerOffsetTop;
        isSitetop = $header.hasClass('header-site-top');
        $window = $(window);


        $(window).on('scroll', function (e) {
            var tpl;
            var isSticky = $window.scrollTop() > changeHeight ? true : false;
            if (isSticky && !($header.hasClass('header-sticky'))) {

                $header.addClass('header-sticky');
                $header.css({opacity:0});
                if (isSitetop) {

                    tpl = _fn.createStickyHeaderHtml();
                    $header.removeClass('header-site-top');
                    var block = '<div class="l-block-site-top-fixed"></div>';
                    $header.wrapAll(block);
                    var div = '<div class="l-block-b l-block-bg"></div>';
                    $header.wrapAll(div);
                    $header.html(tpl);

                }
                _fn.easeIn($header, 0);
            } else if (!isSticky && $header.hasClass('header-sticky')) {
                $header.removeClass('header-sticky');

                if (isSitetop) {
                    tpl = _fn.createSitetopHeaderHtml();
                    $header.unwrap();
                    $header.unwrap();
                    $header.addClass('header-site-top');
                    $header.html(tpl);
                }
            }
        });
    };

    _fn.easeIn = function ($header, op) {
        op = op + 0.1;
        $header.css({opacity:op});
        if (op > 1) {
            return;
        }
        setTimeout(function () {
            _fn.easeIn($header, op);
        }, 50);
    };

    _fn.createStickyHeaderHtml = function () {
        var tpl = [];
        var nav = _fn.createStickyHeaderNavHtml();

        tpl.push('<div class="l-header">');
        tpl.push('<div class="l-header-pd">');
        tpl.push('<input id="header-drawer-chk" type="checkbox" name="header-drawer-chk" class="header-drawer-chk">');
        tpl.push('<label id="js-header-drawer-btn" for="header-drawer-chk" class="header-drawer-btn"></label>');
        tpl.push('<a href="/aurora4d">');
        tpl.push('<img class="header-logo" src="/aurora4d/wp-content/themes/aurora4dplus/assets/img/common/header-aurora4d-logo.png">');
        tpl.push('</a>');
        tpl.push(nav);
        tpl.push('</div>');
        tpl.push('</div>');

        return tpl.join('');
    };

    _fn.createSitetopHeaderHtml = function () {
        var tpl = [];
        var nav = _fn.createStickyHeaderNavHtml();
        var sns = _fn.createStickyHeaderSnsHtml();

        tpl.push('<img class="header-site-top header-logo" src="/aurora4d/wp-content/themes/aurora4dplus/assets/img/common/header-logo-main.png">');
        tpl.push('<img class="header-site-top header-copy" src="/aurora4d/wp-content/themes/aurora4dplus/assets/img/common/header-aurora4d-copy.png">');
        tpl.push('<div class="l-header">');
        tpl.push('<input id="header-drawer-chk" type="checkbox" name="header-drawer-chk" class="header-drawer-chk">');
        tpl.push('<label id="js-header-drawer-btn" for="header-drawer-chk" class="header-drawer-btn"></label>');
        tpl.push(nav);
        tpl.push(sns);
        tpl.push('</div>');

        return tpl.join('');
    };

    _fn.createStickyHeaderSnsHtml = function () {
        var tpl = [];

        tpl.push('<div class="header-sns">');
        tpl.push('<a href="https://www.facebook.com/aurora4djapan/">');
        tpl.push('<div class="header-sns-icon header-sns-icon-fb"></div>');
        tpl.push('</a>');
        tpl.push('<a href="https://twitter.com/aurora4djapan/">');
        tpl.push('<div class="header-sns-icon header-sns-icon-tw"></div>');
        tpl.push('</div>');
        tpl.push('</a>');

        return tpl.join('');
    };

    _fn.createStickyHeaderNavHtml = function () {
        var tpl = [];

        tpl.push('<nav class="header-nav js-header-nav">');
        tpl.push('<div class="l-header-nav">');
        tpl.push('<ul class="header-nav-list">');
        tpl.push('<li class="header-nav-list-item">');
        tpl.push('<a href="/aurora4d/about/">プロジェクトについて</a>');
        tpl.push('<ul class="header-sub-nav-list">');
        tpl.push('<li class="header-sub-nav-list-item">');
        tpl.push('<a href="/aurora4d/about/">オーロラ4D＋</a>');
        tpl.push('</li>');
        tpl.push('<li class="header-sub-nav-list-item">');
        tpl.push('<a href="/aurora4d/about/4d/">オーロラ4D</a>');
        tpl.push('</li>');
        tpl.push('</ul>');
        tpl.push('</li>');
        tpl.push('<li class="header-nav-list-item">');
        tpl.push('<a href="/aurora4d/history/">オーロラの歴史</a>');
        tpl.push('</li>');
        tpl.push('<li class="header-nav-list-item">');
        tpl.push('<a href="/aurora4d/blog/">研究ブログ</a>');
        tpl.push('</li>');
        tpl.push('<li class="header-nav-list-item header-nav-list-item-only-drawer">');
        tpl.push('<a href="/aurora4d/contact/">お問い合わせ</a>');
        tpl.push('</li>');
        tpl.push('</ul>');
        tpl.push('</div>');
        tpl.push('</nav>');

        return tpl.join('');
    };

    app = function (prop) {
        var app,
            m;

        app = {};
        for (m in fn) {
            app[m] = fn[m];
        }
        return app;
    };

    window.timelinemap = window.timelinemap || {};
    window.timelinemap.fn = window.timelinemap.fn || {};
    window.timelinemap.fn.header = app;

}(this));
